import React from 'react';

import { Box, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import DomainNameRow from './DomainNameRow';
import { useCurrentDomainNameVerificationQuery } from './hooks';
import StepTitle, { StepTitleStatus } from './StepTitle';

export default function MailFromSection() {
  const { data, loading } = useCurrentDomainNameVerificationQuery();
  const records = data?.DomainNameVerification.mailFromConfiguration?.records;

  const renderIcon = () => {
    if (!records && loading) {
      return <StepTitleStatus status="LOADING" label="Loading" />;
    }

    if (!records || records.length === 0) {
      return <StepTitleStatus status="PENDING" label="Not setup" />;
    }

    if (records.every((r) => r.isPresent)) {
      return <StepTitleStatus status="SUCCEEDED" label="Verified" />;
    }
    return <StepTitleStatus status="PENDING" label="Pending" />;
  };

  const renderBody = () => {
    if (!records) {
      return (
        <>
          <DomainNameRow recordType="MX" name="" value="" />
          <DomainNameRow recordType="TXT" name="" value="" />
        </>
      );
    }

    return records.map((r, i) => (
      <DomainNameRow key={i} recordType={r.type} isPresent={r.isPresent} name={r.name} value={r.value} />
    ));
  };

  return (
    <Box>
      <StepTitle title="SPF alignment records (recommended)" status={renderIcon()} />

      <Stack spacing={4}>
        <TableContainer>
          <Table size="small" sx={{ '& th, & td': { border: 0 } }}>
            <TableHead>
              <TableRow>
                <TableCell align="center" variant="head" width={64}>
                  Status
                </TableCell>
                <TableCell variant="head" width={96}>
                  Type
                </TableCell>
                <TableCell variant="head">Hostname</TableCell>
                <TableCell variant="head">Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderBody()}</TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}
